export class ProductBrand {
    createdAt: string;
    name: string;
    status: number;
    updatedAt: string;
    _id?: string;
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/productBrand.ts